module.exports = __webpack_public_path__ + "static/your-stylist-result-4-bc84f0b0c99d662165b4569068150195.jpg";